import { Box } from "@material-ui/core";
import { TravaGPTModal } from "@travalendingpool/travagptmodal";
import "@travalendingpool/travagptmodal/dist/assets/style.css";
import { useSelector } from "react-redux";

export default function GptPopup() {
  const isDarkMode = useSelector((state) => state.themeSlice.isDarkMode);
  const accountAddress = useSelector((state) => state.accountSlice.address);

  return (
    <Box style={{ position: "fixed", right: "20px", bottom: "20px", zIndex: 100000000 }}>
      <TravaGPTModal themeMode={isDarkMode ? "dark" : "light"} address={accountAddress} />
    </Box>
  );
}
